import { Col, Row } from "react-bootstrap";
import SyahrulIshak from "assets/images/corporate-profile/exco/CEO.png";
import parse from "html-react-parser";

import "./corporate-profile.css";
import {
  executiveMemberList1,
  executiveMemberList2,
  executiveMemberList3,
} from "constants/corporate-profile";
import BODButton from "./BODButton";
import { ASSETS_BASE_URL } from "constants";

function ExecutiveManagement() {
  return (
    <>
      <div className="container bod-page">
        <h1>
          <span>Corporate</span> Profile
        </h1>

        <BODButton />

        <div style={{ height: "100px" }}></div>

        <Row className="d-flex align-items-center">
          <Col xl={4} xs={1}>
            <div className="divider"></div>
          </Col>
          <Col xl={4} xs={10}>
            <h2 className="divider-title">Executive Management</h2>
          </Col>
          <Col xl={4} xs={1}>
            <div className="divider"></div>
          </Col>
        </Row>

        <div style={{ height: "32px" }}></div>
        <Row className="profile-card-row justify-content-center">
          <Col md={3} className="executive-profile-card">
            <img
              src={`${ASSETS_BASE_URL}assets/images/exco/Syahrul_CEO.png`}
              alt="Syahrul"
              width={"100%"}
              style={{ borderRadius: "8px 8px 0 0" }}
            />
            <div className="content">
              <h1>Mohd Syahrul Ishak</h1>
              <h2>Chief Executive Officer (CEO)</h2>
            </div>
          </Col>
        </Row>
        <Row className="profile-card-row justify-content-center">
          {executiveMemberList1.map((item, index) => (
            <Col md={3} className="executive-profile-card">
              <img className="profile-image" src={item.image} alt="roger" />
              <div className="content">
                <h1>{parse(item.name)}</h1>
                <h2>{item.position}</h2>
              </div>
            </Col>
          ))}
        </Row>
        <Row className="profile-card-row justify-content-center">
          {executiveMemberList2.map((item, index) => (
            <Col md={3} className="executive-profile-card">
              <img className="profile-image" src={item.image} alt="roger" />
              <div className="content">
                <h1>{parse(item.name)}</h1>
                <h2>{item.position}</h2>
              </div>
            </Col>
          ))}
        </Row>
        <Row className="profile-card-row justify-content-center">
          {executiveMemberList3.map((item, index) => (
            <Col md={3} className="executive-profile-card">
              <img className="profile-image" src={item.image} alt="roger" />
              <div className="content">
                <h1>{parse(item.name)}</h1>
                <h2>{item.position}</h2>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default ExecutiveManagement;
